// import { createSelector } from 'reselect';

export const getIsPosting = state => state.getIn(['login', 'isPosting']);
export const getIsGetting = state => state.getIn(['login', 'isGetting']);
export const getErrMsg = state => state.getIn(['login', 'errMsg']);

export const getRedirectTo = state => state.getIn(['login', 'redirectTo']);
export const getTwoFactorAuthenticationId = state => state.getIn(['login', 'twoFactorAuthenticationId']);